import { AHText, Box, ListItem, useLayoutContext } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";

import { Image } from "expo-image";
import { WorkspaceProductSearchItem_workspaceProductSearchHit$key } from "./__generated__/WorkspaceProductSearchItem_workspaceProductSearchHit.graphql";

export function WorkspaceProductSearchListItem(props: {
  isFirst?: boolean;
  isLast?: boolean;
  product: WorkspaceProductSearchItem_workspaceProductSearchHit$key;
  disabled?: boolean;
  disabledReason?: string;
  onPressProduct(id: string): void;
}) {
  const layout = useLayoutContext();
  const result = useFragment(
    graphql`
      fragment WorkspaceProductSearchItem_workspaceProductSearchHit on WorkspaceProductSearchHit {
        id
        nameHighlights {
          isHighlighted
          text
        }
        product {
          id
          imageUrl
          partNumber
          name
        }
      }
    `,
    props.product
  );

  return (
    <ListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      disabled={props.disabled}
      right={
        <Box
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {result.product.imageUrl ? (
            <Image
              source={{ uri: result.product.imageUrl }}
              contentFit="contain"
              style={{
                height: layout.circle.medium,
                width: layout.circle.medium,
              }}
            />
          ) : null}
        </Box>
      }
      onPress={() => props.onPressProduct(result.product.id)}
    >
      {props.disabled && props.disabledReason ? (
        <AHText
          type="subtitle"
          color={props.disabled ? "text-washed" : "text-secondary"}
          spaceBottom="small"
        >
          {props.disabledReason}
        </AHText>
      ) : null}
      <AHText
        type="list-item-title"
        color={props.disabled ? "text-washed" : "text-primary"}
      >
        {result.nameHighlights?.map((highlight, index) =>
          highlight.isHighlighted ? (
            <AHText
              key={index + highlight.text + (highlight.isHighlighted ? 1 : 0)}
              type="list-item-title-selected"
              color={props.disabled ? "text-washed" : "text-primary"}
            >
              {highlight.text}
            </AHText>
          ) : (
            <AHText
              type="list-item-title"
              color={props.disabled ? "text-washed" : "text-primary"}
              key={index + highlight.text + (highlight.isHighlighted ? 1 : 0)}
            >
              {highlight.text}
            </AHText>
          )
        ) ?? result.product.name}
      </AHText>
      {result.product.partNumber !== null ? (
        <ListItem.SubTitle
          color={props.disabled ? "text-washed" : "text-secondary"}
        >
          {result.product.partNumber}
        </ListItem.SubTitle>
      ) : null}
    </ListItem>
  );
}
